import { AuthState } from '@okta/okta-auth-js';

import { BrokerEntries } from '../../services/backend/BrokerEntries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useBrokerEntries: () => BrokerEntries<AuthState> = () => {
  return useBaseApiClient(BrokerEntries);
};
